import {NewtimeDropdownService} from '../../../_services/newtime-dropdown.service';
import { CONFIGCONSTANTS } from './../../../config/app-constants';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';

@Component({
  selector: 'app-newtime-dropdown',
  templateUrl: './newtime-dropdown.component.html',
  styleUrls: ['./newtime-dropdown.component.scss'],
  viewProviders: [ { provide: ControlContainer, useExisting: NgForm } ]
})
export class NewtimeDropdownComponent implements OnInit {
  @Input()
  name: string;
  @Input()
  placeholder: string;
  @Input()
  value: string;
  @Input()
  requiredErrorMsg: string;
  @Input()
  disabledUptoIndex = -1;
  @Input()
  disabled = false;
  @Input()
  form: NgForm;
  @Output()
  timePickerChange: EventEmitter<any> = new EventEmitter();
  timesArray: any[] = [];
  constructor(private timeDropDownService: NewtimeDropdownService) { }

  ngOnInit() { 
    
    this.timesArray = this.timeDropDownService.getTimeArray();
  }
  dropdownChangeHandler($event) {
    this.timePickerChange.emit($event);
  }

}
